import { Link } from "react-router-dom";
import { PageShell } from "../components/Layout/PageShell";
import buttonStyles from "../components/Button/Button.module.css";
import styles from "./RootPage.module.css";

export function NotFoundPage() {
  return (
    <PageShell>
      <div className={styles.page}>
        <div className={styles.card}>
          <h1 className={styles.heading}>Page not found</h1>
          <p className={styles.body}>There's nothing at this address. Check the link, or start again from the home page.</p>
          <div className={styles.actions}>
            <Link className={`${buttonStyles.button} ${buttonStyles.secondary}`} to="/">
              Back to start
            </Link>
          </div>
        </div>
      </div>
    </PageShell>
  );
}
